/**
 * Global serializer for cart mutations.
 *
 * The theme drives the cart from several independent handlers — the core
 * quantity selector (component-cart-items.js), the kit qty stepper / remove
 * (cart-kit.js), the subscription upgrade
 * (cart-drawer-subscription-upsell.js) and the drawer recommendations
 * (cart-drawer-recommendations.js). Each issues its own /cart/change.js or
 * /cart/update.js + /cart/add.js calls. When two run concurrently the slower
 * response morphs the cart section last and wins, so the UI desyncs from the
 * server (stale quantities, phantom rows, even duplicate subscription lines).
 *
 * AdegenCartLock.run() chains every mutation onto a single promise so only one
 * runs at a time, in click order. Consumers fall back to running the task
 * immediately when this script has not loaded, so each handler still works
 * standalone.
 */
(function () {
  if (window.AdegenCartLock) return;

  /** @type {Promise<unknown>} */
  let tail = Promise.resolve();

  window.AdegenCartLock = {
    /**
     * Run a cart mutation after every previously queued one has settled.
     * @template T
     * @param {() => (Promise<T> | T)} task
     * @returns {Promise<T>}
     */
    run(task) {
      const result = tail.then(() => task());
      // Keep the chain alive even when a task rejects, so one failed mutation
      // does not permanently wedge the queue.
      tail = result.then(
        () => undefined,
        () => undefined
      );
      return result;
    },
  };
})();
